// extracted by mini-css-extract-plugin
module.exports = {"form":"styles-module--form--3ZQOF","decorations":"styles-module--decorations--3UFRp"};